import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=c2078450&scoped=true&"
import script from "./ToastNotification.vue?vue&type=script&lang=js&"
export * from "./ToastNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2078450",
  null
  
)

export default component.exports